import React from "react"
import { ModelloClimaDto } from "../../generated"
import { ModelliClimaStore } from "../ModelliClimaStore";

interface Props {
    id: number | undefined | null;
    template: (caldaia: ModelloClimaDto) => JSX.Element | string | number;
}

export default ({ id, template }: Props) => {
    if (!id)
        return null;
    const item = ModelliClimaStore.use(id);
    if (item == null) return null;
    return <>{template(item)}</>;
}
